<button class="c-timer-start__btn" (click)="startTimer()"></button>
